import React from "react";
import { Link } from "@quintype/components";
import PropTypes from "prop-types";
import "./styles.m.css";

function Tag(props) {
  return (
    <Link href={"/topic/" + props.tag.slug} className="story-tag">
      {props.tag.name}
    </Link>
  );
}
Tag.propTypes = {
  tag: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string
  })
};

function StoryTags({ tags = [] }) {
  return (
    <ul styleName="tag-wrapper">
      {tags.map((tag, index) => (
        <li styleName="tag-element" key={index}>
          <Tag key={index} tag={tag} />
        </li>
      ))}
    </ul>
  );
}

export { StoryTags };

StoryTags.propTypes = {
  tags: PropTypes.Array
};
